export enum CollectionOriginEnum {
  TECEO = 'TECEO',
  INTEGRATION = 'INTEGRATION',
}

export type Collection = {
  id: string;
  code: string;
  name: string;
  origin: CollectionOriginEnum;
};
